import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class MultiProjectRoutesStatsService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    const url = "/api/v5/routes-stats";

    return this.http.get(url, { params });
  }
}
